import { useEffect, useRef, useState } from "react";
import Icon from "./Icon";
import s from "./Gallery.module.css";

/** Main photo with arrows and a fullscreen lightbox. The parent owns the index so thumbnails can live elsewhere. */
export default function Gallery({ images, idx, onIdx, alt, dimmed }) {
  const [zoom, setZoom] = useState(false);
  const closeRef = useRef(null);
  const count = images.length;
  const go = (d) => onIdx((idx + d + count) % count);

  useEffect(() => {
    if (!zoom) return;
    closeRef.current?.focus();
    const onKey = (e) => {
      if (e.key === "Escape") setZoom(false);
      if (e.key === "ArrowLeft") go(-1);
      if (e.key === "ArrowRight") go(1);
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { document.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [zoom, idx]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!count) {
    return <div className={`${s.main} ${s.empty}`}><Icon name="image" size={36} /></div>;
  }

  return (
    <>
      <div className={s.main}>
        <button type="button" className={s.zoomBtn} onClick={() => setZoom(true)} aria-label="Zvětšit fotografii">
          <img src={images[idx]} alt={`${alt} — fotografie ${idx + 1} z ${count}`} className={dimmed ? s.dimmed : undefined} />
          <span className={s.zoomHint}><Icon name="maximize" size={16} /></span>
        </button>
        {count > 1 && (
          <>
            <button type="button" className={`${s.arrow} ${s.prev}`} onClick={() => go(-1)} aria-label="Předchozí fotografie"><Icon name="chevron-left" size={22} /></button>
            <button type="button" className={`${s.arrow} ${s.next}`} onClick={() => go(1)} aria-label="Další fotografie"><Icon name="chevron-right" size={22} /></button>
            <span className={s.counter}>{idx + 1} / {count}</span>
          </>
        )}
      </div>

      {zoom && (
        <div className={s.lightbox} role="dialog" aria-modal="true" aria-label={`${alt} — galerie`} onClick={() => setZoom(false)}>
          <img src={images[idx]} alt={`${alt} — fotografie ${idx + 1} z ${count}`} onClick={(e) => e.stopPropagation()} />
          <button ref={closeRef} type="button" className={s.close} onClick={() => setZoom(false)} aria-label="Zavřít galerii"><Icon name="x" size={22} /></button>
          {count > 1 && (
            <>
              <button type="button" className={`${s.arrow} ${s.prev}`} onClick={(e) => { e.stopPropagation(); go(-1); }} aria-label="Předchozí fotografie"><Icon name="chevron-left" size={24} /></button>
              <button type="button" className={`${s.arrow} ${s.next}`} onClick={(e) => { e.stopPropagation(); go(1); }} aria-label="Další fotografie"><Icon name="chevron-right" size={24} /></button>
              <span className={s.counter}>{idx + 1} / {count}</span>
            </>
          )}
        </div>
      )}
    </>
  );
}
